



































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { performanceServer } from '@/api/installServer';
import { dutyListTemplateServer } from '@/api/installServer';
import SafetyAndEnvironmentDialog from '@/views/inspectionContents/safetyAndEnvironmentAssessment/unit/safetyAndEnvironmentDialog.vue';
import { consoleLog } from 'echarts/types/src/util/log';

@Component({
  components: { SafetyAndEnvironmentDialog },
})
export default class EditTemplateDialog extends Vue {
  @Prop(Object) editData!: any; // 传递给编辑页面-数据对象
  @Prop(String) NewType!: any; // 传递给编辑页面-类型
  // 表单数据
  formData: any = {
    name: '',
    year: '',
    id: '',
    spaceId: '',
    itemList: [],
  };
  buttonShowFlag: any = true;
  isLoading: any = false; // 点击确定之后
  formRules: any = {};
  deptObj: any = {};
  postObj: any = [];
  personObj: any = {};
  index: any = 0;
  frequencyOptions: any = [];
  taskTypeOptions: any = [
    {
      value: '固定',
      label: '固定',
    },
    {
      value: '动态',
      label: '动态',
    },
  ];
  private newIndex: any = '';

  /**
   * @desc Vue 创建数据钩子函数
   * @param1 暂无
   * @returns 暂无
   */
  created() {
    const a: any = new Date().getFullYear();
    this.formData.year = a.toString();
    this.deptObj = {};
    this.postObj = [];
    this.isLoading = false; // 点击确定之后
    this.personObj = {};
    if (this.NewType === 'edit') {
      this.getDetails();
    }
    if (this.NewType === 'see') {
      this.buttonShowFlag = false;
      this.getDetails();
    }
    // 获取频次数据
    this.getFrequencyData();
  }

  /**
   * @desc 获取频次数据
   * @param1 暂无
   * @returns 暂无
   */
  getFrequencyData() {
    // 发起接口请求，获取分页数据
    performanceServer
      .getDetailsMapByName({ name: 'frequency' })
      .then((res: any) => {
        for (const key in res.data) {
          this.frequencyOptions.push({
            value: key,
            label: res.data[key],
          }); //属性
        }
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 获取详情
   * @param1 暂无
   * @returns 暂无
   */
  getDetails() {
    dutyListTemplateServer
      .getTemplateDetails(this.editData.id)
      .then((res: any) => {
        this.formData = res.data;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  changeProject(index: any) {
    this.newIndex = index;
    // if (this.formData.assessType) {
    const safetyDialog = 'safetyDialog';
    const safetyDialogComponent = this.$refs[safetyDialog];
    (safetyDialogComponent as any).showDialog(this.formData.assessType); // 传给弹窗的数据 检查标准项(即 检查内容)
    // } else {
    //     this.$message.warning('请先选择考核类型！');
    // }
  }

  /**
   * @desc 检查内容弹窗中所选的数据
   * */
  getData(data: any) {
    if (data) {
      this.formData.itemList[this.newIndex].assessContent = data.assessContent;
      this.formData.itemList[this.newIndex].assessStand = data.assessStand;
      this.formData.itemList[this.newIndex].assessContentId = data.id;
      this.formData.itemList[this.newIndex].assessProjectName = data.assessProject;
    } else {
      this.formData.itemList[this.newIndex].assessContent = '';
      this.formData.itemList[this.newIndex].assessStand = '';
      this.formData.itemList[this.newIndex].assessContentId = '';
      this.formData.itemList[this.newIndex].assessProjectName = '';
    }
    this.$forceUpdate();
  }

  private addList() {
    this.index = this.index + 1;
    this.formData.itemList.push({
      // index: this.index,
      assessContent: '',
      assessContentId: '',
      assessProjectName: '',
      assessStand: '',
      dutyContent: '',
      frequency: 0,
      frequencyUnit: '',
      referWeights: 0,
      remark: '',
      type: '',
    });
  }

  private delList(index: any) {
    if (this.formData.itemList.length === 1) {
      (this as any).$message.warning('至少保留一项');
      return false;
    }
    this.formData.itemList.splice(index, 1);
  }

  /**
   * @desc 点击取消按钮
   */
  close() {
    this.isLoading = false;
    this.formData = {};
    this.$emit('refreshData');
  }

  /**
   * @desc 点击保存
   */
  saveClick() {
    dutyListTemplateServer
      .addTemplate(this.formData)
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('添加成功！');
          this.close();
        } else {
          this.isLoading = false;
          this.$message.warning(res.msg);
        }
      })
      .catch((error: any) => {
        this.isLoading = false;
        this.$message.warning('新增数据失败！');
      });
  }

  /**
   * 保存修改内容
   */
  saveEditClick() {
    dutyListTemplateServer
      .editTemplate(this.formData.id, this.formData)
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('保存成功！');
          this.close();
        } else {
          this.isLoading = false;
          this.$message.warning(res.msg);
        }
      })
      .catch((error: any) => {
        this.isLoading = false;
        this.$message.warning('修改数据失败！');
      });
  }

  /**
   * 保存或者修改前对数据的处理
   */
  saveOrEditBeforeDataHandle() {
    this.isLoading = true;
    this.formData.itemList.forEach((re: any) => {
      re.frequency = parseInt(re.frequency);
      re.referWeights = parseInt(re.referWeights);
    });
    if (this.NewType === 'add') {
      this.saveClick();
    } else {
      this.saveEditClick();
    }
  }
}
